import Icon from 'components/icon';

const IBCTransferArrow = ({ className = '' }: { className?: string }) => {
  return <Icon type="arrow-forward" size="16px" className={`text-on_surface_variant_light ${className}`} />;
};

export default IBCTransferArrow;
